import styled from "styled-components";

const StepDescription = styled.div``

export default StepDescription